import { useEffect, useState } from 'react';
import { quests } from '../services/api/models.ts'; // Adjust the import path if needed
import { useAuth0 } from '@auth0/auth0-react';
import { useAuthHelper } from './useAuthHelper';

const useSubmissionAPI = (questId) => {
    const [isLoading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [error, setError] = useState(null);
    const { isAuthenticated, loginWithRedirect } = useAuth0();
    const { getSafeAccessToken } = useAuthHelper();
  
    useEffect(() => {
      async function getData() {
        try {
          if (!isAuthenticated) {
            await loginWithRedirect();
          }
  
          const accessToken = await getSafeAccessToken();
          
          // If token is null, redirect is happening
          if (!accessToken) {
            return;
          }
          
          const headers = { Authorization: `Bearer ${accessToken}` };
          const options = { headers };
          const limit = 1000, skip = 0, filter = {};
          const response = await quests.questsQuestIdSubmissionsGet(questId, limit, skip, filter, options);
          setData(response.data.data || []);
        } catch (err) {
          setError(err);
        } finally {
          setLoading(false);
        }
      }
  
      getData();
    }, [questId]);
  
    return { isLoading, data, error };
  };
  
  export default useSubmissionAPI;
  